"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _api = require("@react-google-maps/api");

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {},
  input: {
    backgroundColor: "white",
    "& .MuiFilledInput-root": {
      //            backgroundColor: "rgba(255,255,255,.9)",
      "&.Mui-focused": {
        backgroundColor: "white"
      }
    }
  }
}));

const GeopointAutocomplete = ({
  className,
  onChange
}) => {
  const _useState = (0, _react.useState)(null),
        autocomplete = _useState[0],
        setAutocomplete = _useState[1];

  const handleChange = () => {
    if (autocomplete !== null) {
      onChange && onChange(autocomplete.getPlace());
    } else {
      console.log('Autocomplete is not loaded yet!');
    }
  };

  const classes = useStyles();
  return _react.default.createElement("div", {
    className: className || classes.root
  }, _react.default.createElement(_api.Autocomplete, {
    options: {
      types: "geocode"
    },
    onLoad: autocomplete => setAutocomplete(autocomplete),
    onPlaceChanged: handleChange
  }, _react.default.createElement(_TextField.default, {
    className: classes.input,
    label: "Find location",
    placeholder: "Enter a place",
    variant: "filled",
    fullWidth: true
  })));
};

var _default = GeopointAutocomplete;
exports.default = _default;
module.exports = exports.default;